/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useContext, useEffect, useRef, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import Button from "~components/Button";
import Parallaxer from "~components/Parallaxer";
import WavySection from "~components/WavySection";

import pixies from "~assets/images/store-pixies.svg";

const Subscription = ({ subscriptions }) => {
  const {
    addSubscriptionToCart,
    subscriptionOverride,
    setSubscriptionOverride
  } = useContext(AppContext);
  const { device } = useContext(DocumentContext);

  const subscriptionSelectRef = useRef();

  const [subscribeOpen, setSubscribeOpen] = useState(false);

  const { allDataYaml } = useStaticQuery(graphql`
    query Subscription {
      allDataYaml {
        edges {
          node {
            open
          }
        }
      }
    }
  `);

  let open = true;

  if (allDataYaml?.edges?.[0]?.node) {
    ({ open } = allDataYaml.edges[0].node);
  }

  useEffect(() => {
    if (subscriptionOverride) {
      setSubscribeOpen(true);
      setSubscriptionOverride(false);
    }
  }, [subscriptionOverride]);

  useEffect(() => {
    if (window && subscribeOpen && subscriptionSelectRef?.current) {
      const top = subscriptionSelectRef.current.offsetTop + 32;

      window.scrollTo({
        top,
        behavior: `smooth`
      });
    }
  }, [subscribeOpen]);

  //

  const products = [];
  const intervals = {};

  subscriptions.forEach(subscription => {
    if (!subscription?.tags?.[0]) {
      return;
    }

    subscription.tags.forEach(tag => {
      if (tag?.toLowerCase()?.includes(`duration:`)) {
        const tagSplit = tag.split(`:`);
        const interval = tagSplit?.[1];

        if (!intervals?.[interval] && subscription?.variants?.[0]) {
          intervals[interval] = {
            price: subscription.variants[0].price,
            compareAtPrice: subscription.variants[0].compareAtPrice
          };
        }
      } else if (tag?.toLowerCase()?.includes(`title:`)) {
        const tagSplit = tag.split(`:`);
        const title = tagSplit?.[1];

        if (!products?.includes(title)) {
          products.push(title);
        }
      }
    });
  });

  if (!products?.[0] || !Object.keys(intervals)?.[0]) {
    return <></>;
  }

  const [selectedDuration, setSelectedDuration] = useState(
    Object.keys(intervals)[0]
  );
  const [selectedProduct, setSelectedProduct] = useState(products[0]);

  const images = {};

  //

  let defaultId;

  subscriptions.forEach(subscription => {
    const variantId = subscription.variants[0].id;

    if (!defaultId) {
      defaultId = variantId;
    }

    images[variantId] = subscription?.images?.[0]?.originalSrc;
  });

  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(
    defaultId
  );

  useEffect(() => {
    let matchedSubscriptionVariantId;

    subscriptions.forEach(subscription => {
      if (matchedSubscriptionVariantId) {
        return;
      }

      if (
        subscription.title
          .toUpperCase()
          .includes(selectedDuration.toUpperCase()) &&
        subscription.title.toUpperCase().includes(selectedProduct.toUpperCase())
      ) {
        matchedSubscriptionVariantId = subscription.variants[0].id;
      }
    });

    if (matchedSubscriptionVariantId) {
      setSelectedSubscriptionId(matchedSubscriptionVariantId);
    }
  }, [selectedDuration, selectedProduct]);

  //

  return (
    <div ref={subscriptionSelectRef} className="relative">
      <WavySection color="white">
        <Parallaxer className="w-2/3 sm:w-2/5 absolute top-0 md:right-0 left-0 md:left-auto z-20 -mt-24 sm:-mt-24 mr-8 sm:mr-6">
          <img className="w-full relative block" src={pixies} alt="Pixies" />
        </Parallaxer>

        <div className="grid-end-12 sm:grid-end-6 relative overflow-hidden f4">
          {(device && device === `tablet` && (
            <figure className="w-full h-full absolute transform-center">
              <img
                className="w-full h-full relative block object-cover"
                src={images[selectedSubscriptionId]}
                alt="Loaf on a log"
              />
            </figure>
          )) || (
            <figure className="w-full relative block">
              <img
                className="w-full relative block"
                src={images[selectedSubscriptionId]}
                alt="Loaf on a log"
              />
            </figure>
          )}
        </div>

        <article className="grid-end-12 sm:grid-end-6 relative flex flex-col items-center justify-center md:px-6 text-center text-orange">
          {(!subscribeOpen && (
            <>
              <div>
                <h2 className="mt-8 f2">
                  Go wild with a Sourdough Subscription
                </h2>

                <p className="mt-12 f5">From our oven to your doorstep.</p>

                <p className="mt-6 f5">
                  Subscribe and enjoy freshly baked sourdough every week.
                </p>
              </div>

              <Button
                className={`${
                  open ? `` : `opacity-50 pointer-events-none`
                } w-full relative block mt-16 mb-3 pt-5 pb-5`}
                color="dark-green"
                onClick={() => {
                  if (open) {
                    setSubscribeOpen(true);
                  }
                }}
              >
                <span className="f-button">
                  {open ? `Subscribe now` : `Unavailable`}
                </span>
              </Button>
            </>
          )) || (
            <>
              <h2 className="animation-appear-slow mt-8 mb-8 f2 text-dark-green">
                Subscription type
              </h2>

              <>
                <h3 className="mb-2 f4 text-orange">Select your loaf</h3>

                <img
                  className="w-full relative block mb-4"
                  src="/uploads/squiggle-md.svg"
                  alt="Orange squiggle"
                />

                <ul className="w-full relative mb-6">
                  {products.map((loaf, loafIndex) => {
                    const key = `loaf-radio-${loafIndex}`;

                    return (
                      <li key={key} className="w-full relative block">
                        <label
                          htmlFor={`loaf-${loaf}`}
                          className="w-full relative flex items-center justify-start mb-3 text-left"
                        >
                          <input
                            id={key}
                            className="subscription__radio w-8 h-8 relative block cursor-pointer"
                            onChange={() => setSelectedProduct(loaf)}
                            name={`loaf-${loaf}`}
                            type="radio"
                            value={loaf}
                            checked={selectedProduct === loaf}
                          />

                          <span
                            className={`pointer-events-none ml-4 ${
                              device && device === `desktop` ? `f5` : `b1`
                            } text-dark-green`}
                            style={{ width: `calc(100% - 3rem)` }}
                          >
                            {loaf}
                          </span>
                        </label>
                      </li>
                    );
                  })}
                </ul>
              </>

              <>
                <h3 className="mb-2 f4 text-orange">Select duration</h3>

                <img
                  className="w-full relative block mb-4"
                  src="/uploads/squiggle-md.svg"
                  alt="Orange squiggle"
                />

                <ul className="w-full relative mb-6">
                  {Object.keys(intervals).map(intervalKey => {
                    const key = `interval-radio-${intervalKey}`;
                    const intervalPrices = intervals[intervalKey];

                    let discountString = ``;
                    if (
                      intervalPrices?.price &&
                      intervalPrices?.compareAtPrice &&
                      intervalPrices.price !== intervalPrices.compareAtPrice
                    ) {
                      discountString = `(${100 -
                        (intervalPrices.price / intervalPrices.compareAtPrice) *
                          100}% off)`;
                    }

                    return (
                      <li
                        key={key}
                        className="w-full relative flex items-center justify-between mb-3"
                      >
                        <label
                          htmlFor={`interval-${intervalKey}`}
                          className="w-full relative flex items-center justify-start text-left"
                        >
                          <input
                            id={key}
                            className="subscription__radio w-8 h-8 relative block cursor-pointer"
                            onChange={() => setSelectedDuration(intervalKey)}
                            name={`duration-${intervalKey}`}
                            type="radio"
                            value={intervalKey}
                            checked={selectedDuration === intervalKey}
                          />

                          <span
                            className={`pointer-events-none ml-4 ${
                              device && device === `desktop` ? `f5` : `b1`
                            } text-dark-green`}
                            style={{ width: `calc(100% - 3rem)` }}
                          >
                            Every Saturday for {intervalKey} {discountString}
                          </span>
                        </label>

                        <span className="f5 text-dark-green">
                          {intervalPrices.price}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </>

              <Button
                className="animation-appear-slow animation-delay-2 w-full relative block mt-4 mb-3 pt-5 pb-5"
                color="dark-green"
                onClick={() => addSubscriptionToCart(selectedSubscriptionId)}
              >
                <span className="f-button">Subscribe</span>
              </Button>
            </>
          )}
        </article>
      </WavySection>
    </div>
  );
};

export default Subscription;
